// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jyjRJTuwKD76G5j9qDYQ {
  display: flex;
  gap: 15px;
  align-items: center;
}

.JCO7ngHhQenRmWseYco6 {
  display: flex;
  align-items: center;
  gap: 5px;
}

.JjJxzZAesadYCamObGXI {
  border-radius: 6px;
  min-width: 32px;
  height: 32px !important;
  padding: 6px 12px;
  font-size: 14px !important;
  font-weight: 700;
  line-height: 20px;
  color: #3f3f46 !important;
}`, "",{"version":3,"sources":["webpack://./packages/common/utils/components/src/lib/Pagination/Pagination.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AACF","sourceRoot":""}]);
// Exports
export var pagination = `jyjRJTuwKD76G5j9qDYQ`;
export var pageItemContainer = `JCO7ngHhQenRmWseYco6`;
export var pageLink = `JjJxzZAesadYCamObGXI`;
export default ___CSS_LOADER_EXPORT___;
